import script from "./UploadProjectAttachmentsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadProjectAttachmentsModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadProjectAttachmentsModal.vue?vue&type=style&index=0&id=3e8c15be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8c15be"]])

export default __exports__